import { OrderedMap, Record } from 'immutable';
const Articles = Record({
  error: undefined,
  isRequesting: false,
  limit: 0,
  articles: OrderedMap(),
  offset: 0,
  total: 0,
  totalCount: 0
});
export default Articles;